<template lang="pug">
.editable-avatar(@click='pickNewImage')
  template(v-if='previewImgSrc')
    img.rounded-circle(
      :src='previewImgSrc'
      height='96' width='96'
      style='object-fit: cover;'
    )
  template(v-else)
    .img-placeholder.rounded-circle

  .d-flex.overlay.rounded-circle
    template(v-if='isLoading === true')
      LoadingIndicator.m-auto
    template(v-else)
      .avatar.m-auto.bg-white.rounded-circle
        img(src='@/assets/icons/upload-photo-circle.svg')

  input.hidden(
    type="file"
    accept="image/*"
    capture='camera'
    ref='hiddenInput'
    @change='onFileSelected'
  )
</template>

<script>
export default {
  props: {
    src: {},
    isLoading: {
      default: false,
    },
  },
  computed: {
    previewImgSrc() {
      return this.newSrc ? this.newSrc : this.src;
    },
  },
  data: () => ({
    newFile: null,
    newSrc: '',
  }),
  methods: {
    pickNewImage() {
      console.log(this.$refs.hiddenInput);
      this.$refs.hiddenInput.click();
    },

    onFileSelected(e) {
      const selectedFile = e.target.files[0];
      const src = URL.createObjectURL(selectedFile);

      // debug
      // console.log(selectedFile);
      // console.log(src);

      this.newFile = selectedFile;
      this.newSrc = src;
      this.$emit('change', selectedFile);
    },
  },
};
</script>

<style lang="scss">
.editable-avatar {
  position: relative;
  height: 96px;
  width: 96px;

  .overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

    background: rgba(#D8D8D8, 0.5);

    .avatar {
      // position: absolute;
      // transform: translate(50%, 50%) ;
    }
  }

  .hidden {
    display: none;
  }

  cursor: pointer;
  transition: 0.2s;
  &:hover {
    // filter: brightness(1.25);

    // transform: scale(1.05);
    opacity: 0.75;
  }
  &:active {
    filter: brightness(0.5);
    transform: scale(0.9);
  }
}
</style>
